class HovReveal extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.dataset.visible = 'true';
      return;
    }
    this.observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      this.dataset.visible = 'true';
      this.observer.disconnect();
    }, { rootMargin: '0px 0px -8% 0px' });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('hov-reveal')) customElements.define('hov-reveal', HovReveal);

class HovRecentlyViewed extends HTMLElement {
  async connectedCallback() {
    const current = this.dataset.currentHandle;
    const key = 'hovViewedHandles';
    let handles = [];
    try { handles = JSON.parse(localStorage.getItem(key) || '[]'); } catch (_) {}
    const previous = handles.filter((handle) => handle !== current).slice(0, 4);
    localStorage.setItem(key, JSON.stringify([current, ...previous].filter(Boolean).slice(0, 5)));
    if (!previous.length) return;

    const products = (await Promise.all(previous.map(async (handle) => {
      try {
        const response = await fetch(`${window.Shopify.routes.root}products/${encodeURIComponent(handle)}.js`);
        return response.ok ? response.json() : null;
      } catch (_) { return null; }
    }))).filter(Boolean);
    if (!products.length) return;

    const grid = this.querySelector('[data-recent-grid]');
    const cardTemplate = this.querySelector('[data-recent-card-template]');
    if (!grid || !(cardTemplate instanceof HTMLTemplateElement)) return;
    const currency = this.dataset.moneyFormat;
    products.forEach((product) => {
      const fragment = cardTemplate.content.cloneNode(true);
      const link = fragment.querySelector('[data-recent-card-link]');
      const image = fragment.querySelector('[data-recent-card-image]');
      const title = fragment.querySelector('[data-recent-card-title]');
      const currentPrice = fragment.querySelector('[data-recent-card-price]');
      const compareAtPrice = fragment.querySelector('[data-recent-card-compare]');
      if (!link || !image || !title || !currentPrice || !compareAtPrice) return;

      link.href = product.url;
      link.setAttribute('aria-label', product.title);
      image.src = product.featured_image;
      image.alt = product.title;
      title.textContent = product.title;
      const formatMoney = (amount) => {
        try {
          return new Intl.NumberFormat(document.documentElement.lang, { style: 'currency', currency }).format(amount / 100);
        } catch (_) {
          return `${(amount / 100).toFixed(2)} ${currency}`;
        }
      };
      currentPrice.textContent = formatMoney(product.price);
      if (product.compare_at_price && product.compare_at_price > product.price) {
        compareAtPrice.textContent = formatMoney(product.compare_at_price);
        compareAtPrice.hidden = false;
      }
      grid.append(fragment);
    });
    this.hidden = false;
  }
}

if (!customElements.get('hov-recently-viewed')) customElements.define('hov-recently-viewed', HovRecentlyViewed);
